import React from 'react'
import styles from './TablePaginationActions.module.css'
import ButtonPaginationLast from '../Button/ButtonPaginationLast'
import ButtonPaginationNext from '../Button/ButtonPaginationNext'
import ButtonPaginationFirst from '../Button/ButtonPaginationFirst'
import ButtonPaginationPrevious from '../Button/ButtonPaginationPrevious'

const TablePaginationActions = ({
  page,
  count,
  rowsPerPage,
  onPageChange
}) => {
  return (
    <div className={styles.root}>
      <ButtonPaginationFirst
        data-testid="pagination-premiere"
        disabled={(page === 0)}
        onClick={(event) => onPageChange(event, 0)}
      />
      <ButtonPaginationPrevious
        data-testid="pagination-precedente"
        disabled={(page === 0)}
        onClick={(event) => onPageChange(event, page - 1)}
      />
      <ButtonPaginationNext
        data-testid="pagination-suivante"
        onClick={(event) => onPageChange(event, page + 1)}
        disabled={(page >= Math.ceil(count / rowsPerPage) - 1)}
      />
      <ButtonPaginationLast
        data-testid="pagination-derniere"
        disabled={(page >= Math.ceil(count / rowsPerPage) - 1)}
        onClick={(event) => onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1))}
      />
    </div>
  )
}

export default TablePaginationActions
